<script lang="ts">
    import SedeStrumentiComunicazione from "../../../../models/Sede/SedeStrumentiComunicazione";
 

    export let data: SedeStrumentiComunicazione = new SedeStrumentiComunicazione();

    const properties = [
        { name: "Volantini e/o brochure", key: "volantiniBrochure" },
        { name: "Affissioni in spazi (ad es. locandine in bacheche)", key: "affissioni"},
        { name: "Rubrica ricorrente in giornale aziendale", key: "rubricaGiornaleAzienda" },
        { name: "E-mail all user", key: "emailAllUser" },
        { name: "Campagne social tramite post", key: "campagneSocial" },
        { name: "Newsletter", key: "newsletter"},
        { name: "Sito intranet", key: "sitoIntranet" },
        { name: "Altro", key: "altro" },
    ];

    function isAnyFieldSet(): boolean {
        return properties.some((property) => data?.[property?.key] !== undefined);
    }
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
        </tr>
    </thead>
    <tbody>
        {#each properties as property}
            <tr>
                <td class="text-center border border-black">{property?.name}</td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                    {data?.[property?.key] !== undefined ? (data?.[property?.key] ? 'Sì' : 'No') : '-'}
                </td>
            </tr>
        {/each}
    </tbody>
</table>